import type { ImportFileParseResult } from '../utils/aisImport.ts';
import { normalizeImportResult } from '../utils/importResult.ts';

export type AisImportResult = ImportFileParseResult & {
  aisPatientId: string;
  aisLaunchId: string | null;
  openRequestId: string | null;
  // the AIS asked for a Nachforderung, whether or not it can be opened
  reorderRequested: boolean;
  openReorder: boolean;
  // the AIS owns the patient data: the form shows it read-only
  patientDataFromAis: boolean;
  // prefills from the AIS's request the user may change
  acute: boolean;
  labInfo: string | null;
  elgaOptOut: boolean;
};

export class AisRedeemError extends Error {
  constructor(readonly status: number) {
    super(`redeem failed: ${status}`);
  }
}

export const redeemAisContext = async (token: string, contextId: string): Promise<AisImportResult> => {
  const response = await fetch(`${window._env_.API_URL}/rest/ais/context/${encodeURIComponent(contextId)}/redeem`, {
    method: 'POST',
    headers: { authorization: `Bearer ${token}` },
  });
  if (!response.ok) {
    throw new AisRedeemError(response.status);
  }
  return normalizeImportResult((await response.json()) as AisImportResult) as AisImportResult;
};
